import { memberStatuses } from 'enums/memberStatuses';

export default function(memberStatus) {
  return (
    memberStatus === memberStatuses.onHold || memberStatus === memberStatuses.notActive
  );
}
